"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class LocalStorage {
    //   saveBitloopsConfig(bitloopsConfig: BitloopsConfig) {
    //     localStorage.setItem(LOCAL_STORAGE.BITLOOPS_CONFIG, JSON.stringify(bitloopsConfig));
    //   }
    //   getBitloopsConfig(): BitloopsConfig {
    //     const configString = localStorage.getItem(LOCAL_STORAGE.BITLOOPS_CONFIG);
    //     return configString ? JSON.parse(configString) : null;
    //   }
    //   saveSubscriptionId(subscriptionId: string) {
    //     localStorage.setItem(LOCAL_STORAGE.SUBSCRIPTION_ID, subscriptionId);
    //   }
    //   getSubscriptionId() {
    //     return localStorage.getItem(LOCAL_STORAGE.SUBSCRIPTION_ID);
    //   }
    //   deleteSubscriptionId() {
    //     localStorage.removeItem(LOCAL_STORAGE.SUBSCRIPTION_ID);
    //   }
    async saveSessionUuid(sessionId) {
        localStorage.setItem("sessionUuid" /* SESSION_UUID */, sessionId);
    }
    async getSessionUuid() {
        return localStorage.getItem("sessionUuid" /* SESSION_UUID */);
    }
    async deleteSessionUuid() {
        localStorage.removeItem("sessionUuid" /* SESSION_UUID */);
    }
    async saveUser(bitloopsUser) {
        localStorage.setItem("bitloops.auth.userData" /* USER_DATA */, JSON.stringify(bitloopsUser));
    }
    async getUser() {
        const userString = localStorage.getItem("bitloops.auth.userData" /* USER_DATA */);
        return userString ? JSON.parse(userString) : null;
    }
    async deleteUser() {
        localStorage.removeItem("bitloops.auth.userData" /* USER_DATA */);
    }
}
exports.default = LocalStorage;
//# sourceMappingURL=LocalStorage.js.map